
import {of as observableOf, Observable} from 'rxjs';
import {Component, OnInit} from '@angular/core';
import {StaticContentService} from '../../services/static-content.service';

@Component({
    selector: 'jhi-changelog',
    templateUrl: 'changelog.component.html',
    styleUrls: ['changelog.component.scss']
})
export class ChangelogComponent implements OnInit {

    changelog: string;

    constructor(private staticContentService: StaticContentService) {
    }

    ngOnInit(): void {
        this.getChangeLog().subscribe(changelog => this.changelog = changelog);
    }

    getChangeLog(): Observable<string> {
        if (this.changelog) {
            return observableOf(this.changelog);
        }
        return this.staticContentService.getChangeLog(this.changelog);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/changelog/changelog.component.ts